/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { ContentJson } from '@/types/domain/notice/entities/contentEntity';
import type { CategoryItemsType, NoticeStateType } from '@/types/domain/notice/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

const initialState: NoticeStateType = {
  categoryItems: undefined,
  content: undefined,
};

/**
 * Slice
 */
export const noticeSlice = createSlice({
  name: 'notice',
  initialState,
  reducers: {
    /** カテゴリアイテムをセット */
    setCategoryItems: (state, action: PayloadAction<CategoryItemsType | undefined
    >) => {
      state.categoryItems = action.payload;
    },
    /** コンテンツをセット */
    setNoticeItemContent: (state, action: PayloadAction<{ item: ContentJson } | undefined>) => {
      state.content = action.payload;
    },
  },
});
